import { UrlLinks } from "@/shared/config";

const LINKS = [
  { href: UrlLinks.legal.privacy, label: "Privacy Policy" },
  { href: UrlLinks.legal.termsOfService, label: "Terms of Service" },
  { href: UrlLinks.legal.termsOfUse, label: "Terms of Use" },
];

type LegalLinksProps = {
  /** Extra classes for the wrapper (spacing, colour). Links inherit the text colour. */
  className?: string;
};

/** Footer links to the official legal pages. Shown on every page; never copy the terms into the app. */
export function LegalLinks({ className = "" }: LegalLinksProps) {
  return (
    <nav aria-label="Legal" className={`flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-xs ${className}`}>
      {LINKS.map((link) => (
        <a
          key={link.href}
          href={link.href}
          target="_blank"
          rel="noopener noreferrer"
          className="underline-offset-2 hover:underline"
        >
          {link.label}
        </a>
      ))}
    </nav>
  );
}
